import React ,{useState}from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/PartnerZone/Hero/Hero";
import Box from "../../components/PartnerZone/box/Box";
import UpButton from '../../components/UpButton';
//============================================
import styles from "./PartnerZone.module.scss";
import { Helmet } from "react-helmet";
import Login from './Login'
//== 
import  { useContext ,useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
//==
const PartnerZone = ({scroll , lang}) => {
  //---
  const { toggleLanguage } = useContext(LanguageContext);
  useEffect(() => {
    toggleLanguage(lang)
  },);
  //---
  const [section,setSection] = useState('Presentations and Demos') ;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [message, setMessage] = useState(null);
  //-------------------
  const getCredential=(username,password)=>{
    if(username === 'millensyspartner' &&  password === 'MiWeb@@2023'){
      setIsLoggedIn(true)
    }else{
      setMessage('invalid username or password')
    }
  }
  //--------------------
  let title ,subTitle
  if(section === 'Presentations and Demos'){
    title='Presentations and Demos';
    subTitle='Materials for Sales and Marketing'
  }else if (section === 'Help and Training'){
    title='Application Help and Training';
    subTitle='Multimedia Guides, and Materials for Users and Application Specialists'
  }else if (section === 'Technical Documentations'){
    title='Technical Documentations';
    subTitle='Materials for Projects and Technical Staff'
  }else if (section === 'Other Documents'){
    title='Other Documents';
    subTitle='Questionaire, and Quality Certificates'
  }
  return (//
    <div>
      <Helmet>
        <title>Millensys - Partner Zone</title>
        {/* <script type="text/javascript">
            {`            
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "qeh6bpz9s1");
            `}
        </script> */}
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero />
          {
            !isLoggedIn && 
            <main style={{height:'50vh'}}>
              <Login credential={getCredential} message={message} />
              <div className={styles["section__container"]}>
                <h1 className={styles["section__header"]}>welcome to your Partner Zone!</h1>
              </div>
            </main>
          }
          {
            isLoggedIn && (
            <>
              <div className={styles["certification_container"]}>
                <div className={styles["section__container"]}>
                  <p className={styles["section__subheader"]}>Welcome Back</p>
                  <p className={styles["__strong"]}>
                  find all what you need from documentations, help guides, marketing materials, technical specifications and more.
                  </p>
                </div>
                {/* ================================================================================= */}
                <div className={styles.certification}>
                  <button className={`${styles.product___btn} ${styles.box}`} onClick={()=>{setSection('Presentations and Demos')}}>Presentations and Demos</button>
                  <button className={`${styles.product___btn} ${styles.box}`}onClick={()=>{setSection('Help and Training')}}>Help and Training</button>
                  <button className={`${styles.product___btn} ${styles.box}`}onClick={()=>{setSection('Technical Documentations')}}>Technical Documentations</button>
                  <button className={`${styles.product___btn} ${styles.box}`}onClick={()=>{setSection('Other Documents')}}>Other Documents'</button>
                </div>
                <h3 className={styles["section__header"]}>{title}</h3>
                <h6 className={styles["__strong"]}>{subTitle}</h6>
              </div>
              <Box section={section} />
            </>)
          }
        <Footer />
      </div>
    </div>
  );
};

export default PartnerZone;
